import { allRoutes } from '../allRoutes'

export const seriesCategoryNav = ({ slug, activePath, isSeries, totalTeams, tabName, tabSlug, reWriteURLS = [] }) => {
  // const mActivePath = activePath.slice(0, -1)

  const urls = {}
  reWriteURLS?.forEach((e) => {
    urls[e?.eTabType] = `/${e?.sSlug}`
  })

  if (isSeries === 'as') {
    const nav = totalTeams > 2 ? [
      { navItem: 'Home', url: allRoutes.seriesHome(slug), active: allRoutes.seriesHome(slug) === activePath },
      { navItem: 'News', url: allRoutes.seriesNews(`/${slug}/`), active: allRoutes.seriesNews(`/${slug}/`) === activePath },
      // { navItem: 'Videos', url: allRoutes.seriesVideos(`/${slug}/`), active: allRoutes.seriesVideos(`/${slug}/`) === activePath },
      // { navItem: 'Fantasy Articles', url: allRoutes.seriesFantasyArticles(slug), active: allRoutes.seriesFantasyArticles(slug) === activePath },
      {
        navItem: 'Fixtures',
        url: urls?.fixtures || allRoutes.seriesFixtures(`/${slug}/`),
        active: (allRoutes.seriesFixtures(`/${slug}/`) === activePath || urls?.fixtures === activePath)
      },
      {
        navItem: 'Standings',
        url: urls?.standings || allRoutes.seriesStandings(`/${slug}/`),
        active: (allRoutes.seriesStandings(`/${slug}/`) === activePath || urls?.standings === activePath)
      },
      {
        navItem: 'Stats',
        url: urls?.stats || allRoutes.seriesStats(`/${slug}/`),
        active: (allRoutes.seriesStats(`/${slug}/`) === activePath || urls?.stats === activePath)
      },
      {
        navItem: 'Teams',
        url: urls?.teams || allRoutes.seriesTeams(`/${slug}/`),
        active: (allRoutes.seriesTeams(`/${slug}/`) === activePath || urls?.teams === activePath)
      },
      {
        navItem: 'Squads',
        url: urls?.squads || allRoutes.seriesSquads(`/${slug}/`),
        active: (allRoutes.seriesSquads(`/${slug}/`) === activePath || urls?.squads === activePath)
      },
      { navItem: 'Archives', url: allRoutes.seriesArchives(`/${slug}/`), active: allRoutes.seriesArchives(`/${slug}/`) === activePath },
      { navItem: 'Fantasy Tips', url: allRoutes.seriesFantasyTips(`/${slug}/`), active: allRoutes.seriesFantasyTips(`/${slug}/`) === activePath }
    ] : [
      { navItem: 'Home', url: allRoutes.seriesHome(slug), active: allRoutes.seriesHome(slug) === activePath },
      { navItem: 'News', url: allRoutes.seriesNews(`/${slug}/`), active: allRoutes.seriesNews(`/${slug}/`) === activePath },
      // { navItem: 'Videos', url: allRoutes.seriesVideos(`/${slug}/`), active: allRoutes.seriesVideos(`/${slug}/`) === activePath },
      // { navItem: 'Fantasy Articles', url: allRoutes.seriesFantasyArticles(slug), active: allRoutes.seriesFantasyArticles(slug) === activePath },
      {
        navItem: 'Fixtures',
        url: urls?.fixtures || allRoutes.seriesFixtures(`/${slug}/`),
        active: (allRoutes.seriesFixtures(`/${slug}/`) === activePath || urls?.fixtures === activePath)
      },
      {
        navItem: 'Stats',
        url: urls?.stats || allRoutes.seriesStats(`/${slug}/`),
        active: (allRoutes.seriesStats(`/${slug}/`) === activePath || urls?.stats === activePath)
      },
      {
        navItem: 'Squads',
        url: urls?.squads || allRoutes.seriesSquads(`/${slug}/`),
        active: (allRoutes.seriesSquads(`/${slug}/`) === activePath || urls?.squads === activePath)
      },
      { navItem: 'Archives', url: allRoutes.seriesArchives(`/${slug}/`), active: allRoutes.seriesArchives(`/${slug}/`) === activePath }
      // { navItem: 'Fantasy Tips', url: allRoutes.seriesFantasyTips(`/${slug}/`), active: allRoutes.seriesFantasyTips(`/${slug}/`) === activePath }
    ]
    return nav
  } else if (isSeries === 's' || isSeries === 'pct') {
    return [
      { navItem: 'Home', internalName: 'home' },
      { navItem: 'News', internalName: 'news' }
      // { navItem: 'Videos', internalName: 'videos' }
    ]
  } else if (isSeries === 'gt' || isSeries === 'p' || isSeries === 't' || isSeries === 'fac') {
    return [
      { navItem: 'Home', internalName: 'home' },
      { navItem: 'News', internalName: 'news' }
      // { navItem: 'Fantasy Articles', internalName: 'fantasyArticle' }
    ]
  } else {
    return []
  }
}

export const matchDetailNav = (slug, activePath, isStandingSlug, status, seriesTotalTeams, isCommentryStart) => {
  const commonTab = [
    { navItem: 'News', url: allRoutes.matchDetailNews(`/${slug}/`), active: allRoutes.matchDetailNews(`/${slug}/`) === activePath },
    { navItem: 'Overs', url: allRoutes.matchDetailOvers(`/${slug}/`), active: allRoutes.matchDetailOvers(`/${slug}/`) === activePath },
    { navItem: 'Live Stats', url: allRoutes.matchDetailLiveStats(`/${slug}/`), active: allRoutes.matchDetailLiveStats(`/${slug}/`) === activePath },
    { navItem: 'Other Fixtures', url: allRoutes.matchDetailUpcoming(`/${slug}/`), active: allRoutes.matchDetailUpcoming(`/${slug}/`) === activePath },
    { navItem: 'Fantasy Tips', url: allRoutes.matchDetailFantasyTips(`/${slug}/`), active: allRoutes.matchDetailFantasyTips(`/${slug}/`) === activePath }
  ]
  if (seriesTotalTeams > 2) {
    return [
      { navItem: 'Info', url: allRoutes.matchDetail(slug), active: allRoutes.matchDetail(slug) === activePath },
      { navItem: 'Commentary', url: allRoutes.matchDetailCommentary(slug), active: allRoutes.matchDetailCommentary(slug) === activePath },
      { navItem: 'Scorecard', url: allRoutes.matchDetailScorecard(`/${slug}/`), active: allRoutes.matchDetailScorecard(`/${slug}/`) === activePath },
      { navItem: 'Standings', url: allRoutes.matchDetailStandings(`/${slug}/`), active: allRoutes.matchDetailStandings(`/${slug}/`) === activePath },
      ...commonTab
    ]
  } else {
    return [
      { navItem: 'Info', url: allRoutes.matchDetail(slug), active: allRoutes.matchDetail(slug) === activePath },
      { navItem: 'Commentary', url: allRoutes.matchDetailCommentary(slug), active: allRoutes.matchDetailCommentary(slug) === activePath },
      { navItem: 'Scorecard', url: allRoutes.matchDetailScorecard(`/${slug}/`), active: allRoutes.matchDetailScorecard(`/${slug}/`) === activePath },
      ...commonTab
    ]
  }
}

export const searchNav = (type) => {
  return [
    { navItem: 'All', url: allRoutes.search, active: !type },
    { navItem: 'News', url: allRoutes.searchNews, active: type === 'news' },
    // { navItem: 'Video', url: allRoutes.searchVideo, active: type === 'video' },
    { navItem: 'Series', url: allRoutes.searchSeries, active: type === 'series' },
    { navItem: 'Players', url: allRoutes.searchPlayer, active: type === 'players' },
    { navItem: 'Team', url: allRoutes.searchTeam, active: type === 'team' }
  ]
}

export const headerMenu = [{
  sTitle: 'Cricket',
  sSlug: '/',
  isNotInternal: true
},
{
  sTitle: 'Football',
  sSlug: '/football',
  isNotInternal: true
},
{
  sTitle: 'Formula1',
  sSlug: '/formula1-racing',
  isNotInternal: true
},
{
  sTitle: 'Tennis',
  sSlug: '/tennis',
  isNotInternal: true
}
]

export const cricketHeaderMenu = [{
  sTitle: 'Cricket',
  sSlug: '/',
  isNotInternal: false
},
{
  sTitle: 'Football',
  sSlug: '/football',
  triangle: '/',
  isNotInternal: true
},
{
  sTitle: 'Formula1',
  sSlug: '/formula1-racing',
  isNotInternal: false
},
{
  sTitle: 'Tennis',
  sSlug: '/tennis',
  isNotInternal: true
}
// {
//   sTitle: 'GCL',
//   sSlug: `${ONE_TURF_BASE_URL}chess-2024`
// }
]

export function formatURL(url) {
  if (url === '/') return ''
  return url.startsWith('/') ? url : '/' + url
}
